import React from 'react'
import {useSelector} from 'react-redux'
import _ from 'lodash'
//import CountdownWidget from 'src/shared/widgets/countdown_widget'
import RenderedHtmlContent from "src/shared/virtual_congress/components/rendered_html_content";

let ClosedPage = function(props){

  let footerText = useSelector(state => state.footerText).trim()
  let closedHeadline = useSelector(state => state.closedHeadline).trim()
  let closedText = useSelector(state => state.closedText).trim()
  let tagOwner = useSelector(state => state.tagOwner)
  
  return (
    <div className="r-container col-sm-12">
      <div className="closed">
        <h1 className="page-header r-header-headline mt-2 mb-4" id="header_headline" dangerouslySetInnerHTML={{ __html: closedHeadline}}></h1>
        <RenderedHtmlContent className="r-header-text" html={closedText.replace(/@tag_owner_id@/g, tagOwner ? tagOwner.id : "")}/>
      </div>
      <div className="r-footer">
        <div dangerouslySetInnerHTML={{ __html: footerText}} className="r-footer-text"/>
      </div>
    </div>
  )
}
export default ClosedPage;